export * from './all-tickets/all-tickets.component';
export * from './my-tickets/my-tickets.component';
export * from './ticket-action/ticket-action.component';
export * from './ticket-detail/ticket-detail.component';
export * from './ticket-item/ticket-item.component';
export * from './ticket-list/ticket-list.component';
export * from './ticket-monitoring/ticket-monitoring.component';
export * from './ticket-thread/ticket-thread.component';

export * from './ticket.module';



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/index.ts